import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { submitOnChangeTicketType } from '../handler/HelpdeskCreateTicketHandler';
import { submitOnchangeProject } from '../handler/QaTicketHandler';

export const DialogConfirmChangeTicketTypeDraftFlow = props => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        if(props.isHelpDesk){
            props.setIsConfirmChangeTicketType(false);
        }
        if(props.isQA){
            props.setIsEdited(false);
            props.setIsOpenDialogQAConfirmChangeTicketType(false);
        }
    };

    const onHandlerConfirmChangeHelpDesk = () => {
        submitOnChangeTicketType(props.createTicketTypeSelectTemp, props);
        props.setIsConfirmChangeTicketType(false);

        // Reset external customer form data
        props.setExternalCustomerProjectList([]);
        props.setExternalCustomerRequestKeyword('');
        props.setExternalCustomerRequestProject({});
        props.setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
    };

    const onHandlerConfirmChangeQA = () => {
        submitOnchangeProject(props.selectedProjectChange, props);
        props.setIsOpenDialogQAConfirmChangeTicketType(false);
        props.setIsEdited(false);
    };

    return (
        <Dialog
            open={props.isConfirmChangeTicketType}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.isHelpDesk ? I18n.get('USER04MSG022') : I18n.get('USER04MSG016')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={props.isHelpDesk ? onHandlerConfirmChangeHelpDesk : (props.isQA ? onHandlerConfirmChangeQA : null)}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
